import {useAuthsState} from "../auths/authsContext";
import {useEffect, useState} from "react";
import {clientLog} from "../clientLog";

/**
 * Hook to get a list of objects, which maps museum IDs to collection IDs for museums
 * where the museum has access to the NB publishing application.
 * @returns {*[]}
 */
export const useMuseumIdsWithNbAccess = () => {
    const {userData: user, museumCollections} = useAuthsState();
    const [museumIdsWithNbAccess, setMuseumIdsWithNbAccess] = useState([]);

    const getMuseumsWithNbAccess = () => museumIdsWithNbAccess;

    const getNBHandoverAppId = () => {
        if (!window._env_ || !window._env_.REACT_APP_EKULTUR_HANDOVER_APP_ID) {
            clientLog('error', 'Please define REACT_APP_EKULTUR_HANDOVER_APP_ID in your environment variables to enable NB access checks.', 'usemuseumidswithnbaccess');
            return null;
        } else {
            return window._env_.REACT_APP_EKULTUR_HANDOVER_APP_ID;
        }
    };

    /**
     * Hook used to determine whether the user has access to the NB publishing application.
     */
    useEffect(() => {
        if (!museumCollections || !user || !user.appAccess || !user.appAccess?.museums) {
            return false;
        }

        const {museums: userMuseums} = user.appAccess;
        if (typeof userMuseums === "undefined") {
            return false;
        }

        const appNbHandoverAppId = getNBHandoverAppId(); // Application ID for NB Handover application
        if (!appNbHandoverAppId) {
            setMuseumIdsWithNbAccess([]);
        } else {
            // 1. Filter the list of museums to only contain collections valid for the user.
            // 2. Filter the museums to only those that have access to the M24 application.
            // 3. Map the resulting museums to an object containing museumId and collectionId.
            const museumIdsWithAccess = userMuseums
                .filter(um => museumCollections.find(mc => mc.museumId === um.id))
                .filter(m => {
                    return m.applications.find(a => a.id === appNbHandoverAppId) !== undefined;
                }).map(mm => ({
                    'museumId': mm.id,
                    'collectionId': museumCollections.find(mc => mc.museumId === mm.id).collectionId
                }));
            setMuseumIdsWithNbAccess(museumIdsWithAccess);
        }
    }, [user, museumCollections]);

    return {
        getMuseumsWithNbAccess
    };
};
